import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { staticWelcomePageQueryOptions } from "~/app/api/pageData/forkPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { StaticPageHeader } from "~/features/navigation/components/StaticPageHeader/StaticPageHeader";

function ForkPageRoute() {
  const result = useLoaderData({
    from: "/static/welcome",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame
      variant={shellProps.variant}
      metadata={result.metadata}
      header={<StaticPageHeader />}
      hideFooter
    >
      {null}
    </StorefrontShellFrame>
  );
}

export const forkPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/static/welcome",
  loader: ({ context }) => loadForkPageData(context),
  component: ForkPageRoute,
});

export async function loadForkPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(staticWelcomePageQueryOptions());

  return unwrapPageInitialData(result);
}
